import Box from '@mui/material/Box';
import { ReactElement } from 'react';
import classNames from 'classnames';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

import DatePicker from '~/ui/components/inputs/DatePicker';
import RadioGroup from '~/ui/components/inputs/RadioGroup';

import isStatusDone from '~/ui/pages/Visits/utils/isStatusDone';

import { testingStatusOptions } from '~/ui/pages/Visits/constants/toxicologyOptions';
import { IBloodDrawn } from '../AddVisit/types';

import styles from '../Form/Form.module.scss';

interface IBloodDrawnProps<TFieldValues extends FieldValues = FieldValues> {
  bloodDrawn: IBloodDrawn | null;
  control: Control<TFieldValues>;
  errors: FieldErrors;
}

const BloodDrawn = <TFieldValues extends FieldValues = FieldValues>({
  bloodDrawn,
  control,
  errors,
}: IBloodDrawnProps<TFieldValues>): ReactElement => (
  <Box className={styles.column}>
    <RadioGroup
      control={control}
      name="bloodDrawn.status"
      errors={errors}
      options={testingStatusOptions}
      label="Blood Drawn"
      size="small"
      className={styles.rowRadioGroup}
      unselectable
    />
    {isStatusDone(bloodDrawn?.status) && (
      <Box className={classNames(styles.rowRadioGroup, styles.selectWidth)}>
        <DatePicker
          control={control}
          errors={errors}
          name="bloodDrawn.drawDate"
          openTo="date"
          label="Draw Date"
          maxDate={new Date().toISOString()}
        />
      </Box>
    )}
  </Box>
);

export default BloodDrawn;
